
import styles from './ArticlePage.module.css';
import { MarkupLayout } from '../../components/ui/markupLayout/MarkupLayout';
import { Article } from '../../components/articlePage/article/Article';
import { Button } from '../../components/ui/button/Button';
export function ArticlePage() {
    return (
        <section className={styles.section}>
            <MarkupLayout>
                <div className={styles.container}>
                    <Article />
                    <Button variant={"yellow"} link={'/catalog'} fontWeight='bold' width={'w-426'} type='link'>
                        Каталог подбора
                    </Button>
                </div>
            </MarkupLayout>
        </section>
    );
} 